<app-card [title]="'service.settings.measured-values.header'" titleSize="large" height="initial">
    <ng-template #content>
        <app-table
            [items]="defaultSetting()?.values || []"
            [columns]="columns"
            translatePrefix="service.settings.measured-values."
            [hideCheckboxes]="true"
            dataKey="name"
            [showPagination]="false"
        >
            <ng-template pTemplate="name" let-data="data">
                <span>{{ 'enum.measuredValues.' + data | translate }}</span>
            </ng-template>

            <ng-template pTemplate="description" let-item="item">
                <span>{{ 'enum.measuredValuesDescription.' + item.name | translate }}</span>
            </ng-template>

            <ng-template pTemplate="use" let-item="item">
                <app-check-input
                    [showLabel]="false"
                    (selectedValueChange)="useItem(item, $event)"
                ></app-check-input>
            </ng-template>

            <ng-template pTemplate="icon" let-data="data">
                <svg-icon [name]="data"></svg-icon>
            </ng-template>
        </app-table>
    </ng-template>
    <ng-template #footer>
        <app-action-buttons
            (primaryClickEvent)="save()"
            [secondaryButtonVisibility]="false"
        ></app-action-buttons>
    </ng-template>
</app-card>
